import React from 'react'
import type { LegalHistoryProps } from '@/features/enrollment'

export default function LegalHistory({ enrollmentData, updateEnrollmentData, errors }: LegalHistoryProps) {
  return (
    <>
      {/* Legal History */}
      <div>
        <label className="block text-sm font-medium text-accent-900 mb-2">
          Have you filed a lawsuit or been a defendant in a lawsuit? <span className="text-red-500">*</span>
          {enrollmentData.filedLawsuit === 'No' && (
            <span className="ml-2 text-xs text-gray-500">
              (Auto-selected: No)
            </span>
          )}
        </label>
        <div className="flex items-center space-x-4">
          <label className="flex items-center">
            <input 
              type="radio" 
              name="filedLawsuit" 
              value="Yes" 
              checked={enrollmentData.filedLawsuit === 'Yes'} 
              onChange={() => updateEnrollmentData('filedLawsuit', 'Yes')} 
              className="form-radio text-primary-600" 
            />
            <span className="ml-2 text-accent-700">Yes</span>
          </label>
          <label className="flex items-center">
            <input 
              type="radio" 
              name="filedLawsuit" 
              value="No" 
              checked={enrollmentData.filedLawsuit === 'No'} 
              onChange={() => updateEnrollmentData('filedLawsuit', 'No')} 
              className="form-radio text-primary-600" 
            />
            <span className="ml-2 text-accent-700">No</span>
          </label>
        </div>
        {errors.filedLawsuit && (
          <p className="mt-1 text-sm text-red-600">{errors.filedLawsuit}</p>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-accent-900 mb-2">
          Have you ever been convicted of a misdemeanor or felony? <span className="text-red-500">*</span>
          {enrollmentData.convictedMisdemeanorFelony === 'No' && (
            <span className="ml-2 text-xs text-gray-500">
              (Auto-selected: No)
            </span>
          )}
        </label>
        <div className="flex items-center space-x-4">
          <label className="flex items-center">
            <input 
              type="radio" 
              name="convictedMisdemeanorFelony" 
              value="Yes" 
              checked={enrollmentData.convictedMisdemeanorFelony === 'Yes'} 
              onChange={() => updateEnrollmentData('convictedMisdemeanorFelony', 'Yes')} 
              className="form-radio text-primary-600" 
            />
            <span className="ml-2 text-accent-700">Yes</span>
          </label>
          <label className="flex items-center">
            <input 
              type="radio" 
              name="convictedMisdemeanorFelony" 
              value="No" 
              checked={enrollmentData.convictedMisdemeanorFelony === 'No'} 
              onChange={() => updateEnrollmentData('convictedMisdemeanorFelony', 'No')} 
              className="form-radio text-primary-600" 
            />
            <span className="ml-2 text-accent-700">No</span>
          </label>
        </div>
        {errors.convictedMisdemeanorFelony && (
          <p className="mt-1 text-sm text-red-600">{errors.convictedMisdemeanorFelony}</p>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-accent-900 mb-2">
          Do you receive SSDI (Social Security Disability Insurance) benefits? <span className="text-red-500">*</span>
          {enrollmentData.receivesSSDI === 'No' && (
            <span className="ml-2 text-xs text-gray-500">
              (Auto-selected: No)
            </span>
          )}
        </label>
        <div className="flex items-center space-x-4">
          <label className="flex items-center">
            <input 
              type="radio" 
              name="receivesSSDI" 
              value="Yes" 
              checked={enrollmentData.receivesSSDI === 'Yes'} 
              onChange={() => updateEnrollmentData('receivesSSDI', 'Yes')} 
              className="form-radio text-primary-600" 
            />
            <span className="ml-2 text-accent-700">Yes</span>
          </label>
          <label className="flex items-center">
            <input 
              type="radio" 
              name="receivesSSDI" 
              value="No" 
              checked={enrollmentData.receivesSSDI === 'No'} 
              onChange={() => updateEnrollmentData('receivesSSDI', 'No')} 
              className="form-radio text-primary-600" 
            />
            <span className="ml-2 text-accent-700">No</span>
          </label>
        </div>
        {errors.receivesSSDI && (
          <p className="mt-1 text-sm text-red-600">{errors.receivesSSDI}</p>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-accent-900 mb-2">
          Do you receive SSI (Supplemental Security Income) benefits? <span className="text-red-500">*</span>
          {enrollmentData.receivesSSI === 'No' && (
            <span className="ml-2 text-xs text-gray-500">
              (Auto-selected: No)
            </span>
          )}
        </label>
        <div className="flex items-center space-x-4">
          <label className="flex items-center">
            <input 
              type="radio" 
              name="receivesSSI" 
              value="Yes" 
              checked={enrollmentData.receivesSSI === 'Yes'} 
              onChange={() => updateEnrollmentData('receivesSSI', 'Yes')} 
              className="form-radio text-primary-600" 
            />
            <span className="ml-2 text-accent-700">Yes</span>
          </label>
          <label className="flex items-center">
            <input 
              type="radio" 
              name="receivesSSI" 
              value="No" 
              checked={enrollmentData.receivesSSI === 'No'} 
              onChange={() => updateEnrollmentData('receivesSSI', 'No')} 
              className="form-radio text-primary-600" 
            />
            <span className="ml-2 text-accent-700">No</span>
          </label>
        </div>
        {errors.receivesSSI && (
          <p className="mt-1 text-sm text-red-600">{errors.receivesSSI}</p>
        )}
      </div>
    </>
  )
}
